export class Link {
	href: string
	templated: boolean
}


// WEBPACK FOOTER //
// ./src/app/models/link.model.ts